module.exports = __webpack_public_path__ + "img/DE05751.da44bf28.png";